/* global QuestionAnswer */
"use strict";

($dt => {
	// Localized Constants
	const { TOPIC_TYPES, QUESTION_TYPES } = $dt.TopicGrid.Constants; 

	// Localized Functions
	const {
		get_topic_type_variant,
		toggle_variant_visibility,
		calculate_chaperones,
		topic_type_requires_class_grade,
		on_nothing,
		topic_type_requires_dynamic_questions,
	} = $dt.TopicGrid.Functions;

	/**
	 * 
	 * @param {HTMLElement} wrapper_elem 
	 * @param {Array} questions_list 
	 * @param {SchedulingInfo} scheduling_info
	 */
	const build_class_questions = (wrapper_elem, questions_list, scheduling_info) => {
		wrapper_elem.innerHTML = '';
		questions_list.forEach((question, question_index) => {
			let field_inner_html = '';
			let field_type = '';
			let previous_answer = '';
			if (question_index < scheduling_info.class_info_questions.length) {
				previous_answer = scheduling_info.class_info_questions[question_index].answer;
			}
			if (question.type === QUESTION_TYPES.FREE_TEXT) {
				field_type = 'text';
				field_inner_html = `
					<label for="question_${question_index}">${question.question}</label>
					<input type="text" name="question_${question_index}" id="question_${question_index}" value="${previous_answer}" maxlength="50">
				`;
			} else {
				field_type = 'select';
				let options_html = '<option value="">Please select...</option>';
				question.options.forEach(option_text => {
					const selected = previous_answer === option_text ? 'selected' : '';
					options_html += `<option value="${option_text}" ${selected}>${option_text}</option>`;
				});
				field_inner_html = `
					<div class="dropdown-input">
						<label for="question_${question_index}">${question.question}</label>
						<select id="question_${question_index}" name="question_${question_index}">
							${options_html}
						</select>
					</div>
				`;
			}
			const field_elem = `
				<div class="d3df_field d3df_field_type_${field_type} d3df_field_question_${question_index} class-question">
					${field_inner_html}
					<span class="d3df_error_message"></span>
				</div>
			`;

			wrapper_elem.innerHTML += field_elem;
		});
	};

	/**
	 * Global setups
	 * @param {Block} block 
	 * @param {InnerScreen} inner_screen 
	 * @param {*} controller 
	 */
	const setup_screen = (block, inner_screen, controller) => {
		const { inner_elem } = inner_screen;
		const [ button_prev_elem, button_next_elem, form_elem ] = [
			inner_elem.querySelector('.button-prev'),
			inner_elem.querySelector('.button-next'),
			inner_elem.querySelector('form')
		];

		inner_screen.ScreenIsValid = () => {
			button_next_elem.removeAttribute('disabled');
		};
		inner_screen.ScreenIsInvalid = () => {
			button_next_elem.setAttribute('disabled', '');
		};

		// Back to topic details
		button_prev_elem.addEventListener('click', () => {
			const { current_screen } = block;
			current_screen.inner = 0;
			controller.SetScreenUI(block);
		});

		// Transition next screen
		const transition_next_screen = () => {
			const { current_screen } = block;
		
			// Class Grade Submit
			current_screen.inner = 3;
			controller.UpdateCalendar(block);
			controller.SetScreenUI(block);
		};

		$dt.OnDevelformsReady($df => {
			$df.RegisterFormPreparedEvent('eglxyorder', form => {

				const validate_form_submit = () => {
					const { current_topic, scheduling_info, d3df_page_options } = block;

					if (topic_type_requires_dynamic_questions(current_topic) || topic_type_requires_class_grade(current_topic)) {
						controller.StartWaiting(block);

						form.currentContainer = form_elem;

						// Form processing
						let data = $df.serialize(form_elem);

						// Contact Info if Anonymous
						controller.SetContactInfoFormData(block, data);

						// Known scheduling info for progressive form saving
						const scheduled_form_data = {};
						controller.SetSchedulingFormData(block, scheduled_form_data);

						// Merge scheduled data and form data
						data = {
							...scheduled_form_data,
							...data
						};

						const on_success = () => {
							// Save details
							scheduling_info.class_grade = data.class_grade;

							// Save Questions
							scheduling_info.class_info_questions = [];
							current_topic.class_questions.forEach((source_question, index) => {
								scheduling_info.class_info_questions.push(
									new QuestionAnswer(
										index,
										source_question,
										data['question_' + index]		
									)
								);
							});

							//console.log(scheduling_info);

							// Transition Screen
							transition_next_screen();
						};

						const on_validation_failed = errors => {
							// Focus into view question fields
							let scrolled = false;
							errors.forEach((err) => {
								const match = err.Key.match(/^question_([0-9]+)$/);
								if (match) {
									const question_elem = form_elem.querySelector('#question_' + match[1]);
									if (!scrolled && question_elem) {
										scrolled = true;
										question_elem.scrollIntoView();
										question_elem.focus();
									}
								}
							});

							controller.FormValidationFailed(form, errors);
						};

						const on_complete = () => {
							controller.EndWaiting(block);
						};

						// Update page options
						d3df_page_options.pageIndex = 0;
						d3df_page_options.onSuccess = on_success;

						// Validation only submission
						controller.ResetFormValidation(form);
						form.submit(data, on_success, on_validation_failed, on_nothing, on_complete, d3df_page_options);
					} else {
						// Reset class grade
						scheduling_info.class_grade = false;

						// Reset dynamic questions
						scheduling_info.class_info_questions = [];

						// Transition Screen
						transition_next_screen();
					}
				};

				button_next_elem.addEventListener('click', $dt.Util.debounce(validate_form_submit, $df.debounceThreshold));
				button_next_elem.removeAttribute('disabled');
			});
			
		});
	};

	/**
	 * This screen is for entering the number of attendees.
	 * 
	 * @param {Block} block 
	 * @param {InnerScreen} inner_screen 
	 * @param {*} controller 
	 */
	$dt.TopicGrid.ScreenFunctions.o0_i2 = (block, inner_screen, controller) => {
		const { inner_elem } = inner_screen;

		// Class Grade Elems
		const [
			class_details_elem,
			class_grade_wrapper_elem,
			class_questions_wrapper_elem,
			class_grade_input,
			class_grade_error_elem
		] = [
			inner_elem.querySelector('.class-details-collect'),
			inner_elem.querySelector('.class-grade-collect'),
			inner_elem.querySelector('.class-questions-collect'),
			inner_elem.querySelector('select[name="class_grade"]'),
			inner_elem.querySelector('.d3df_error_message')
		];

		// Screen Setup
		setup_screen(block, inner_screen, controller);

		// Inner contents organized by the topic type
		const topic_type_variants = [
			$dt.TopicGrid.SelectAttendees.createOnsiteVariant(inner_elem.querySelector('.onsite-attendees'), block, inner_screen),
			$dt.TopicGrid.SelectAttendees.createOnsiteSelfGuidedVariant(inner_elem.querySelector('.onsite-self-guided-attendees'), block, inner_screen),
			$dt.TopicGrid.SelectAttendees.createStgVariant(inner_elem.querySelector('.stg-attendees'), block, inner_screen),
			$dt.TopicGrid.SelectAttendees.createCommunityVariant(inner_elem.querySelector('.reservation-attendees'), block, inner_screen),
		];

		// On showing this screen
		inner_screen.Show = () => {
			const { current_topic, scheduling_info } = block;

			// Disable button
			inner_screen.ScreenIsInvalid();

			// Clear selected date in case user pressed back button from calendar screen
			controller.ClearSelectedDate(block);

			// Select current variant based on the topic type selected
			const current_variant = get_topic_type_variant(current_topic.topic_type, topic_type_variants);
			toggle_variant_visibility(current_variant, topic_type_variants);

			switch (current_topic.topic_type) {
				case TOPIC_TYPES.ONSITE:
					scheduling_info.reservation_attendees = 1;
					scheduling_info.children_attendees = '';
					scheduling_info.paid_adult_attendees = 0;
					scheduling_info.chaperone_attendees = calculate_chaperones(scheduling_info.children_attendees, current_topic);
					break;

				case TOPIC_TYPES.ONSITE_SELF_GUIDED:
					scheduling_info.reservation_attendees = 1;
					scheduling_info.children_attendees = '';
					scheduling_info.paid_adult_attendees = 0;
					break;

				case TOPIC_TYPES.SCIENCE_TO_GO:
					scheduling_info.reservation_attendees = 1;
					scheduling_info.children_attendees = '';
					break;

				case TOPIC_TYPES.COMMUNITY:
					scheduling_info.reservation_attendees = 0;
					break;
			}

			// Hide form by default
			class_details_elem.style.display = 'none';

			// Toggle class grade by type
			switch (current_topic.topic_type) {
				case TOPIC_TYPES.ONSITE:
				case TOPIC_TYPES.SCIENCE_TO_GO:
					// Show class grade
					class_grade_wrapper_elem.style.display = '';
					class_details_elem.style.display = '';

					// Set class grade
					if (scheduling_info.class_grade) {
						class_grade_input.value = scheduling_info.class_grade;
					}

					// Reset error message
					class_grade_error_elem.innerHTML = '';
					break;
				case TOPIC_TYPES.ONSITE_SELF_GUIDED:
				case TOPIC_TYPES.COMMUNITY:
				default:
					// Hide class grade
					class_grade_wrapper_elem.style.display = 'none';
					break;
			}

			// Class Info Questions by type
			switch (current_topic.topic_type) {
				case TOPIC_TYPES.ONSITE:
				case TOPIC_TYPES.SCIENCE_TO_GO:
				case TOPIC_TYPES.ONSITE_SELF_GUIDED:
				case TOPIC_TYPES.COMMUNITY:
					// Show class questions
					class_details_elem.style.display = '';
					class_questions_wrapper_elem.style.display = '';
					// Build class grade html
					build_class_questions(class_questions_wrapper_elem, current_topic.class_questions, scheduling_info);
					break;
				default:
					// Hide class questions
					class_questions_wrapper_elem.style.display = 'none';
					class_questions_wrapper_elem.innerHTML = '';
					break;
			}

			// Run variant show
			current_variant.show();
		};

		// Run Variant Setups
		topic_type_variants.forEach(variant_setup => {
			variant_setup.setup();
		});		
	};

})(window.d3_wp_themejs);
